"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var auth_1 = require("../features/apis/auth");
var btb_1 = require("../features/apis/btb");
var dashboard_1 = require("../features/apis/dashboard");
var users_1 = require("../features/apis/users");
var wallet_1 = require("../features/apis/wallet");
var auth_2 = require("../features/slices/auth");
var content_dialog_1 = require("../features/slices/content-dialog");
var message_dialog_1 = require("../features/slices/message-dialog");
exports.store = (0, toolkit_1.configureStore)({
    devTools: process.env.ENVIRONMENT !== "PROD",
    reducer: (_a = {
            auth: auth_2.authReducer,
            messageDialog: message_dialog_1.messageDialogReducer,
            contentDialog: content_dialog_1.contentDialogReducer
        },
        _a[auth_1.authApi.reducerPath] = auth_1.authApi.reducer,
        _a[users_1.usersApi.reducerPath] = users_1.usersApi.reducer,
        _a[dashboard_1.dashboardApi.reducerPath] = dashboard_1.dashboardApi.reducer,
        _a[btb_1.btbApi.reducerPath] = btb_1.btbApi.reducer,
        _a[wallet_1.walletApi.reducerPath] = wallet_1.walletApi.reducer,
        _a),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat([
            auth_1.authApi.middleware, //
            users_1.usersApi.middleware,
            dashboard_1.dashboardApi.middleware,
            btb_1.btbApi.middleware,
            wallet_1.walletApi.middleware,
        ]);
    },
});
